import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Validator from '@/utils/Validator'
import Utility from '@/utils/Utility'

export default {
  name: 'SetupPassword',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.pageTitle + ' | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      processing: false,
      // 入力値
      inpPassword: '',
      inpPasswordConfirm: '',
      // QRコード
      showQrCode: false,
      qrCode: null
    }
  },
  computed: {
    ...mapState({

    }),
    ...mapGetters({
      getMeta: 'meta/get'
    }),
    
    siteName() {
      return Constants.SiteInfo.name
    },
    pageTitle () {
      return 'ログイン'
    },

    // validate
    inpPasswordIsValid () {
      if (!this.isClickedConfirm) return true
      return Validator.validText(this.inpPassword)
    },
    inpPasswordConfirmIsValid () {
      if (!this.isClickedConfirm) return true
      return this.inpPassword === this.inpPasswordConfirm
    },
    formIsValid () {
      // return true
      return this.inpPasswordIsValid &&
        this.inpPasswordConfirmIsValid
    },
    disableConfirmButton () {
      return !Validator.validText(this.inpPassword) ||
        this.inpPassword !== this.inpPasswordConfirm
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      completeSetup: 'auth/completeSetup',
      signout: 'auth/signout'
    }),
    confirmData () {
      if (!this.formIsValid) return
      this.processing = true

      let parameters = {
        request: {
          LoginPassword: this.inpPassword
        }
      }
      console.log('parameters : ', parameters)

      // ユーザのメールアドレスをアクティベート
      ApiManager.request(
        ['auth'],
        ['v1UserPasswordSetup'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            this.completeSetup(res[0].data)

            this.qrCode = res[0].data.qrcode
            this.showQrCode = true

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    goSignin () {
      this.signout()
        .then(() => {
          this.$router.push({
            name: 'Signin'
          })
        })
    }
  }
}